"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const forms_1 = require("@pbl/pbl-react-core/lib/models/forms");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const config_1 = require("../config/config");
const Icon_1 = require("../icon/Icon");
const DateFieldValidator_1 = require("./DateFieldValidator");
const PhoneInputMask_1 = require("./PhoneInputMask");
const TextFieldValidator_1 = require("./TextFieldValidator");
class FieldRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.getField = () => {
            const { field, inputProps, onChange, className, labelProps } = this.props;
            const props = inputProps ? inputProps : {};
            const fieldValue = this.getFieldValue(field);
            const changeListener = (event) => {
                const value = field.type === 'phone' && event.target.value && event.target.value.length > 0
                    ? event.target.value.replace(/\D+/g, '')
                    : event.target.value;
                if (!!field.maxLength && value.length > field.maxLength) {
                    onChange(value.substring(0, field.maxLength));
                    return;
                }
                onChange(value);
            };
            this.getInputProps(field, props);
            if (field.disabledAutofill) {
                props.autoComplete = field.type === 'password' ? 'new-password' : 'off';
            }
            const fieldType = field.type === 'email' ? 'email' : 'text';
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && ((0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ style: labelProps.labelStyle }, { children: [field.label, labelProps.isRequiredLabel ? ' *' : ''] }))), (0, jsx_runtime_1.jsx)(TextFieldValidator_1.default, Object.assign({}, props, { placeholder: field.placeholder, id: field.key, label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? field.label : null, value: fieldValue, onChange: changeListener, className: className, inputProps: Object.assign(Object.assign({}, props.inputProps), { role: labelProps === null || labelProps === void 0 ? void 0 : labelProps.role, 'aria-required': field.isRequired ? 'true' : 'false', 'aria-label': field.label }), variant: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.variant) || config_1.config.internalConfig.FIELDS_VARIANT, multiline: field.multiline, minRows: field.multiline ? field.numberOfLines : 1, validationSchema: field.validationSchema, disabled: field.disabled || props.disabled, type: field.secureTextEntry && !this.state.showPassword ? 'password' : fieldType }))] }));
        };
        this.getRadio = () => {
            const { field, onChange, className } = this.props;
            const changeListener = (_1, value) => {
                onChange(value);
            };
            return ((0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, className: className }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: [(0, jsx_runtime_1.jsx)(core_1.FormLabel, { children: field.isRequired ? field.label + ' *' : field.label }), field.description ? (0, jsx_runtime_1.jsx)(core_1.FormHelperText, { children: field.description }) : null] })), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(core_1.RadioGroup, Object.assign({ name: field.key, "aria-label": field.label, row: true, value: field.value || '', onChange: changeListener }, { children: field.options &&
                                field.options.map((option, index) => {
                                    var _a;
                                    return ((0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { color: 'primary', value: option.value, control: (0, jsx_runtime_1.jsx)(core_1.Radio, {}), label: option.label }, (_a = option.label) !== null && _a !== void 0 ? _a : index));
                                }) })) }))] })));
        };
        this.getDateField = () => {
            const { field, inputProps, onChange, className, InputProps: InputPropsRest, labelProps } = this.props;
            const value = field.fieldValue ? field.fieldValue : null;
            const props = inputProps ? inputProps : { value, onChange };
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && ((0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ style: labelProps.labelStyle }, { children: [field.label, labelProps.isRequiredLabel ? ' *' : ''] }))), (0, jsx_runtime_1.jsx)(DateFieldValidator_1.default, Object.assign({ keyboardVariant: true, id: field.key === 'dateOfBirth' ? 'Date Of Birth' : field.key }, props, { label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? field.label : null, placeholder: field.placeholder, inputProps: Object.assign(Object.assign({}, (props.inputProps || {})), { 'aria-required': field.isRequired ? 'true' : 'false', 'aria-label': field.label, autoComplete: 'off' }), value: value, onChange: onChange, labelFunc: this.formatDate, className: className, disabled: field.disabled || props.disabled, validationSchema: field.validationSchema, inputVariant: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.variant) || 'filled', minDate: field.minValue, maxDate: field.maxValue, InputProps: InputPropsRest }))] }));
        };
        this.getAddressField = () => {
            var _a;
            const { field, onChange, className, inputProps } = this.props;
            const address = field.value ? field.value : undefined;
            const props = inputProps ? inputProps : {};
            props.className = className;
            props.variant = 'filled';
            props.multiline = field.multiline;
            props.minRows = field.multiline ? field.numberOfLines : 1;
            const changeListener = (event) => {
                const value = event.target.value;
                const updatedAddress = new forms_1.Address(address);
                updatedAddress.apartmentNumber = value;
                onChange(updatedAddress);
            };
            return ((0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, className: className }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControl, Object.assign({ className: className }, { children: this.props.getGoogleAddressInput ? this.props.getGoogleAddressInput(props) : null })) })), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, style: { marginTop: this.props.theme.spacing() } }, { children: (0, jsx_runtime_1.jsx)(TextFieldValidator_1.default, { disabled: !address, variant: (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.variant) !== null && _a !== void 0 ? _a : config_1.config.internalConfig.FIELDS_VARIANT, onChange: changeListener, "aria-label": `Apartment/Suite Number`, className: className, value: address ? address.apartmentNumber : '', label: 'Apartment/Suite Number', placeholder: 'Apartment/Suite Number' }) }))] })));
        };
        this.getBooleanField = () => {
            const { field, onChange, className } = this.props;
            const onToggle = () => {
                onChange(!field.value);
            };
            return ((0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { className: className, control: (0, jsx_runtime_1.jsx)(core_1.Checkbox, { color: "primary", checked: !!field.value, onChange: onToggle, value: "checked", style: {
                        padding: this.props.theme.spacing() / 2,
                        paddingLeft: this.props.theme.spacing() + this.props.theme.spacing() / 2
                    } }), label: field.isRequired ? field.label + ' *' : field.label }));
        };
        this.formatDate = (date) => (date ? date.format('MM/DD/YYYY') : '');
        this.handleClickShowPassword = () => {
            this.setState({ showPassword: !this.state.showPassword });
        };
        this.state = {
            showPassword: false
        };
    }
    getFieldValue(field) {
        const fieldValue = field.type === 'phone' && (!field.fieldValue || field.fieldValue.trim().length < 1) ? undefined : field.fieldValue;
        return fieldValue === null ? undefined : fieldValue;
    }
    getInputProps(field, props) {
        if (field.type === 'phone') {
            props.InputProps = {
                inputComponent: PhoneInputMask_1.default
            };
        }
        else if (field.type === 'password') {
            props.InputProps = {
                endAdornment: ((0, jsx_runtime_1.jsx)(core_1.InputAdornment, Object.assign({ position: "end" }, { children: (0, jsx_runtime_1.jsx)(core_1.IconButton, Object.assign({ "aria-label": this.state.showPassword ? 'Password visible' : 'Password hidden', onClick: this.handleClickShowPassword }, { children: this.state.showPassword ? ((0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: 'custom', iconName: 'icon-show' })) : ((0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: 'custom', iconName: 'icon-hide' })) })) })))
            };
        }
    }
    render() {
        const { field } = this.props;
        switch (field.type) {
            case 'email':
            case 'string':
            case 'password':
                return this.getField();
            case 'radio':
                return this.getRadio();
            case 'dateOfBirth':
            case 'date':
                return this.getDateField();
            case 'phone':
                return this.getField();
            case 'address':
                return this.getAddressField();
            case 'boolean':
                return this.getBooleanField();
            default:
                return null;
        }
    }
}
exports.default = (0, core_1.withTheme)((0, react_i18next_1.withTranslation)()(FieldRenderer));
//# sourceMappingURL=FieldRenderer.js.map